import { useQuery } from "react-query";
import { getRolesWithUsers } from "../../../../../actions/Utilities/RolePermission";

export const useGetRolesWithUsers = () => {
  return useQuery("GetRolesWithUsers", getRolesWithUsers, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
